module.exports = __webpack_public_path__ + "img/serviceplanner-banner-laptop-en.5fb64985.webp";